import { FC, useEffect } from "react";
import { getQticketsUrl } from "../../utils";

interface BuyTicketWrapperProps {
    url: string;
    provider?: 'qtickets' | 'ticketland';
    children?: React.ReactNode;
}

export const BuyTicketWrapper: FC<BuyTicketWrapperProps> = ({
    url,
    provider='qtickets',
    children,
 }) => {
    useEffect(() => {
        if (!url) {
            return;
        }

        if (provider === 'qtickets') {
            setTimeout(() => {
                window?.qTickets?.init();
            }, 1000);
        }
    }, [provider, url]);

    if (!url) {
        return null;
    }

    const href = getQticketsUrl(url);

    return (
        <a href={href} className="hover:no-underline">
            {children}
        </a>
    );
}